// extracted by mini-css-extract-plugin
module.exports = {"customFooter":"AppFooter_customFooter_emOvD","footerContent":"AppFooter_footerContent_22gNx"};